// Shared config for the Command Center wake word(s). Each entry is a word +
// an optional free-form command it runs when SPOKEN. Saying "hey <word> <rest>"
// runs "<rest>" (any question/command); a bare word runs its saved command, or
// just opens the bar to listen. Persisted per-browser + broadcast.
const KEY = "iw_cc_wake_words";
const EVT = "iw-wake-words";
const DEFAULT = [{ word: "command", command: "" }];

function esc(w) { return String(w).replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); }

function normalize(list) {
  if (!Array.isArray(list)) return DEFAULT.map((e) => ({ ...e }));
  const out = list.map((it) => (typeof it === "string"
    ? { word: it.trim().toLowerCase(), command: "" }
    : { word: String(it.word || "").trim().toLowerCase(), command: String(it.command || "").trim() }
  )).filter((e) => e.word);
  return out.length ? out.slice(0, 4) : DEFAULT.map((e) => ({ ...e }));
}

export function getWakeEntries() {
  try { return normalize(JSON.parse(localStorage.getItem(KEY))); } catch { return DEFAULT.map((e) => ({ ...e })); }
}

export function getWakeWords() { return getWakeEntries().map((e) => e.word); }

export function setWakeEntries(list) {
  const final = normalize(list);
  try { localStorage.setItem(KEY, JSON.stringify(final)); } catch { /* quota */ }
  try { window.dispatchEvent(new CustomEvent(EVT, { detail: { entries: final, words: final.map((e) => e.word) } })); } catch { /* noop */ }
  return final;
}

// Back-compat helper (accepts a plain string array too).
export function setWakeWords(list) {
  return setWakeEntries((list || []).map((w) => (typeof w === "string" ? { word: w, command: "" } : w)));
}

export function buildWakeRegex(words) {
  const ws = (words && words.length ? words : ["command"]).map(esc);
  return new RegExp(`\\b(?:hey\\s+)?(?:${ws.join("|")})\\b`, "i");
}

// First matching wake entry + the text spoken AFTER it (for one-breath commands).
export function matchWake(txt, entries) {
  const list = entries && entries.length ? entries : getWakeEntries();
  for (const e of list) {
    const re = new RegExp(`\\b(?:hey\\s+)?${esc(e.word)}\\b`, "i");
    const m = re.exec(txt);
    if (m) return { entry: e, after: txt.slice(m.index + m[0].length).replace(/^[,.!?\s]+/, "").trim() };
  }
  return null;
}

export const WAKE_EVENT = EVT;
